import { render, staticRenderFns } from "./EmptyOrderList.vue?vue&type=template&id=254e315d&scoped=true&"
import script from "./EmptyOrderList.vue?vue&type=script&lang=js&"
export * from "./EmptyOrderList.vue?vue&type=script&lang=js&"
import style0 from "./EmptyOrderList.vue?vue&type=style&index=0&id=254e315d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e315d",
  null
  
)

export default component.exports